// @flow
import React from 'react';

type Props = {
  style?: any,
  children?: any | Array<any>
};

const TabItem = ({ children, style }: Props) => {
  return (
    <div className="c-tab-item" style={style}>
      {children}
    </div>
  );
};

TabItem.defaultProps = {
  children: null,
  style: {}
};

export default TabItem;
